module.exports = __webpack_public_path__ + "img/Den-rode-front_Bilde-fra-konsentrasjonsleir-under-Bibelske-allusjoner.da878321.jpg";